import { module as modujs } from "modujs";

import Plyr from "plyr";

export default class extends modujs {
	constructor(m) {
		super(m);
	}

	init() {
		this.player = new Plyr(this.el);
	}

	play() {
		this.player.play();
	}

	pause() {
		this.player.pause();
	}

	destroy() {
		this.player.destroy();
	}
}
